import { endOfDay, startOfDay } from 'date-fns';

import type { DailyTaskDefaultFilters } from '../../../../../types';

export const transformFiltersForBackend = (filters: DailyTaskDefaultFilters) => {
  const {
    startDate,
    endDate,
    responsible,
    userFunctions,
    status,
    participants,
    typeDate,
    resolutionLevel,
    text,
    locations,
  } = filters;

  return {
    [typeDate === 'registeredDate' ? 'startDatetime' : typeDate]: {
      $gte: startDate
        ? (typeDate === 'registeredDate' ? startDate : startOfDay(startDate)).toISOString()
        : undefined,
      $lte: endDate ? (typeDate === 'registeredDate' ? endDate : endOfDay(endDate)).toISOString() : undefined,
    },
    userFunction: userFunctions,
    responsible: {
      id: responsible,
    },
    resolutionLevel,
    status: {
      $in: status,
    },
    participants: {
      id: participants,
    },
    location: {
      id: locations,
    },
    $or: [
      {
        title: {
          $containsi: text,
        },
      },
      {
        description: {
          $containsi: text,
        },
      },
    ],
  };
};
